<div class="d-flex flex-column gap-2">
  <div class="review-entry-label" i18n>Social Insurance Number</div>
  <div class="d-flex gap-2 align-items-center">
    <div class="review-entry-value" [style.width.rem]="6.5">{{ formattedSin$ | async }}</div>
    <button
      class="no-style-button"
      type="button"
      aria-label="Toggle sin display"
      i18n-aria-label
      [style.line-height]="0"
      [disabled]="disabled"
      (click)="toggleShowFullSin()">
      <img [src]="iconSrc$ | async" alt="" [style.height.rem]="1" [style.width.rem]="1" />
    </button>
  </div>
  <hr class="m-0" />
</div>
